import i18next from 'i18next'
import React from 'react'
import { capitalize } from '../cmsPage/blocks/courseDetailsBlock/courseDetailsBlockUtils'
import { Link } from 'widgets-for-react'
import { NotFoundLayout } from '../notFound/notFoundLayout'
import { EventTemplate } from '../models/Events/Events'

export interface CourseDateScheduleProps {
  eventId: string
  rf: string
  eventTemplateData: EventTemplate
}

export const CourseDateScheduleLayout = (props: CourseDateScheduleProps) => {
  // Prepare data
  const { eventId, rf, eventTemplateData } = props
  const { id: eventTemplateId, events } = eventTemplateData
  const currEvent = events.find(b => b.id == eventId);
  if (!currEvent) return <NotFoundLayout/>;
  const { sessions } = currEvent

  // Update document meta title
  const blockTitle = currEvent.name != eventTemplateData.name ? `${currEvent.name} | ${eventTemplateData.name}` : currEvent.name
  document.title = blockTitle

  const teachterDataAvailable = sessions.some(session => session.teachers)
  const decodeHtml = (html: string) => {
    const txt = document.createElement('textarea')
    txt.innerHTML = html
    return txt.value
  }

  return (
    <div className="block block--datatable">
      <div className="block__inner container--m gutter--m spacing--m">
        <header className="block__header block__header--intro">
          <h2 className="block__title title--m">{blockTitle}</h2>
          <p className="block__intro text--l">
            {i18next.t('courseDateSchedule:note')}
          </p>
        </header>

        <div className="block__content">
          <table className="datatable">
            {
              <>
                <thead>
                  <tr>
                    <th className="narrow">
                      {i18next.t('courseDateSchedule:startDateLabel')}
                    </th>
                    <th className="full">
                      {i18next.t('courseDateSchedule:modulesLabel')}
                    </th>
                    <th className="narrow">
                      {i18next.t('courseDateSchedule:locationLabel')}
                    </th>
                    <th className="narrow">
                      {i18next.t('courseDateSchedule:startTimeLabel')}
                    </th>
                    <th className="narrow">
                      {i18next.t('courseDateSchedule:endTimeLabel')}
                    </th>
                    {teachterDataAvailable && <th className="narrow">
                      {i18next.t('courseDateSchedule:teachersLabel')}
                    </th>}
                  </tr>
                </thead>

                <tbody>
                  {sessions.map(session => {
                    const startDate = session.start_date && new Date(session.start_date)
                    const endDate = session.end_date && new Date(session.end_date)

                    const readableStartTime = startDate ? startDate.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }) : "n.v.t."
                    const readableEndTime = endDate ? endDate.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }) : "n.v.t."

                    const description = session.description
                    const location = session.city ?? "N.V.T."
                    const teachers = session.teachers

                    return (
                      <tr key={session.id}>
                        <td>
                          <span className="datatable__key">
                            {i18next.t('courseDateSchedule:startDateLabel')}
                          </span>{' '}
                          <time dateTime={startDate?.toUTCString()}>{startDate?.toLocaleDateString('nl-NL')}</time>
                        </td>
                        <td>
                          <span className="datatable__key">
                            {i18next.t('courseDateSchedule:modulesLabel')}
                          </span>{' '}
                          <span
                            dangerouslySetInnerHTML={{
                              __html: decodeHtml(description)
                            }}
                          ></span>
                        </td>
                        <td>
                          <span className="datatable__key">
                            {i18next.t('courseDateSchedule:locationLabel')}
                          </span>{' '}
                          {capitalize(location)}
                        </td>
                        <td>
                          <span className="datatable__key">
                            {i18next.t('courseDateSchedule:startTimeLabel')}
                          </span>{' '}
                          <td><time dateTime={startDate?.toUTCString()}>{readableStartTime}</time></td>
                        </td>
                        <td>
                          <span className="datatable__key">
                            {i18next.t('courseDateSchedule:endTimeLabel')}
                          </span>{' '}
                          <td><time dateTime={endDate?.toUTCString()}>{readableEndTime}</time></td>
                        </td>
                        { teachterDataAvailable && <td>
                          <span className="datatable__key">
                            {i18next.t('courseDateSchedule:teachersLabel')}
                          </span>{' '}
                          {teachers?.join(', ')}
                        </td>
                        }
                      </tr>
                    )
                  })}
                </tbody>
              </>
            }
          </table>
        </div>

        <footer className="block__footer block__clickables">
          <div className="block__clickable">
            {rf === 'course' ? (
              (
                <Link
                  className="button button--primary"
                  to={`/opleidingen/inschrijven?eventId=${eventTemplateId}`}
                >
                  <span className="button__label">
                    {i18next.t('courseDateSchedule:courseRegisterLinkLabel')}
                  </span>
                </Link>
              )
            ) : (
              <button
                className="button button--secondary button--print"
                onClick={() => window.print()}
              >
                <span className="button__label">
                  {i18next.t('courseDateSchedule:printPageButtonLabel')}
                </span>
              </button>
            )}
          </div>
        </footer>
      </div>
    </div>
  )
}
